import { ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const testTitleStyles = xcss({
  font: 'font.heading.xsmall',
  fontWeight: 'font.weight.heading',
  color: 'color.text',
  display: 'flex',
  alignItems: 'center',
  gap: 'space.075',
  paddingInlineEnd: 'space.200',
});

export const TestTitle = ({ children }: { children: ReactNode }) => (
  <Box xcss={testTitleStyles}>{children}</Box>
);
